import { useState, useEffect } from 'react';

interface UseNavVisibilityOptions {
  breakpoint?: number;  // Default: 900
}

interface UseNavVisibilityReturn {
  ocultarEnMobile: boolean;
  mobileStylesFromParent: boolean;
  showDesktopNav: boolean;
  showMobileNav: boolean;
}

export const useNavVisibility = (
  options: UseNavVisibilityOptions = {}
): UseNavVisibilityReturn => {
  const breakpoint = options.breakpoint || 900;
  
  const [ocultarEnMobile, setOcultarEnMobile] = useState(
    () => window.innerWidth < breakpoint
  );
  const [mobileStylesFromParent, setMobileStylesFromParent] = useState(
    () => window.innerWidth < breakpoint
  );

  useEffect(() => {
    const handleResize = () => {
      const windowWidth = window.innerWidth;
      const isMobile = windowWidth < breakpoint;
      setOcultarEnMobile(isMobile);
      setMobileStylesFromParent(isMobile);
    };

    // Ejecutar una vez al montar
    handleResize();

    // Escuchar cambios de tamaño
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [breakpoint]);

  return {
    ocultarEnMobile,
    mobileStylesFromParent,
    showDesktopNav: !ocultarEnMobile,
    showMobileNav: ocultarEnMobile
  };
};

export default useNavVisibility;

